// extracted by mini-css-extract-plugin
export default {"wrapper":"ww-z","viewport":"xw-z","container":"yw-z","slide":"zw-z"};